import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { GeneralInvokeOption } from 'src/types';

// 获取系统剪贴板内容
export function getClipboardData(option?: GeneralInvokeOption) {
  return MacleJSBridge.beforeInvoke(APINames.Native.GET_CLIPBOARD_DATA, option);
}
